import * as yup from "yup";

const containsUpperCase = (string) => /[A-Z]/.test(string);

const getRolesForMainRole = (mainRole, mappedRoles) => {
  let matchingRoles = [];
  matchingRoles = mappedRoles?.filter(
    (e) =>
      e?.main_role_id?.main_role_name?.toLowerCase() ===
      mainRole?.toLowerCase(),
  );
  return matchingRoles;
};

const userBaseSchema = yup.object().shape({
  first_name: yup.string().label("first name").required(),
  last_name: yup.string().label("last name").required(),
  user_name: yup
    .string()
    .label("username")
    .required()
    .test(
      "is-uppercase",
      "Please Enter Lowercase Letters",
      (value) => !containsUpperCase(value),
    )
    .test(
      "is-white-spaces",
      "Please Remove Spaces",
      (value) => value === undefined || value.indexOf(" ") === -1,
    ),
  email: yup.string().label("email").email().required(),
  mobile: yup
    .string()
    .label("mobile")
    .matches(/^$|^\d{3}-\d{3}-\d{4}$/, "invalid mobile number format"),
});

export const getBulkUserUploadSchema = (hotelList, mainRoles, mappedRoles) => {
  return yup.object({
    formData: yup.array().of(
      yup.object().shape({
        ...userBaseSchema.fields,
        hotel_code: yup
          .string()
          .label("hotel code")
          .test("invalid-hotel-code", "Invalid hotel code", (value) => {
            const indexval = hotelList.findIndex(
              (hotel) => hotel.hotel_code === value,
            );
            return indexval !== -1;
          })
          .required(),
        main_role: yup
          .string()
          .label("main role")
          .test("invalid-main-role", "Invalid main role", (value) => {
            const indexval = mainRoles.findIndex(
              (mainRole) => mainRole.main_role_name === value,
            );
            return indexval !== -1;
          })
          .required(),
        role: yup
          .string()
          .label("role")
          .test("invalid-role", "Invalid role", (value, { parent }) => {
            const indexval = getRolesForMainRole(
              parent?.main_role,
              mappedRoles,
            ).findIndex((role) => role.role_name === value);
            return indexval !== -1;
          })
          .required(),
      }),
    ),
  });
};

export default {
  getBulkUserUploadSchema,
};
